export default __webpack_public_path__ + "static/media/category_32.c5ddb5f9.png";